// extracted by mini-css-extract-plugin
export default {"background":"AddFriends_background__KLVkQ","peopleList":"AddFriends_peopleList__gYE6r"};